import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

// Main css.
import './index.css'

// Theme.
import { ThemeProvider } from 'styled-components'
import Theme from './theme'

import { logIn } from './firebase/auth'

logIn('mateo@mateo.com', '123456')

ReactDOM.render(<ThemeProvider theme={Theme}> <App /> </ThemeProvider>, document.getElementById('root'))
